<script lang="ts">
    import type {
        PermissionDescriptor,
        Permission,
        ResourceType,
    } from "../../../../../../admin-service-typescript-client";
    import { permissionsArray } from "../../../../../GlobalHelper/Permissions";

    const permissionArray = permissionsArray;

    export let accessGrantDescriptors: PermissionDescriptor[];
    export let editable: boolean = false;
    export let changePermissionsHandler: (
        permissions: Permission[],
        resourceType: ResourceType
    ) => void;
    console.log(accessGrantDescriptors);
</script>

<div>
    <table class="table full-width">
        <thead>
            <tr>
                <th />
                <th>Lesen</th>
                <th>Erstellen</th>
                <th>Bearbeiten</th>
                <th>Löschen</th>
                <th>Alle</th>
            </tr>
        </thead>
        <tbody>
            {#each permissionArray as permissionObject}
                <tr>
                    <td>{permissionObject.topicDisplay}</td>
                    <td>
                        {#if accessGrantDescriptors.length > 0 && accessGrantDescriptors?.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType) ? permissionObject.read(accessGrantDescriptors.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType).permissions) : false}
                            <span
                                class="icon has-text-success {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleRead(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                ).permissions
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-on" />
                            </span>
                        {:else}
                            <span
                                class="icon has-text-danger {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleRead(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                )?.permissions || []
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-off" />
                            </span>
                        {/if}
                    </td>
                    <td>
                        {#if accessGrantDescriptors.length > 0 && accessGrantDescriptors?.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType) ? permissionObject.create(accessGrantDescriptors.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType).permissions) : false}
                            <span
                                class="icon has-text-success {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleCreate(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                ).permissions
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-on" />
                            </span>
                        {:else}
                            <span
                                class="icon has-text-danger {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleCreate(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                )?.permissions || []
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-off" />
                            </span>
                        {/if}
                    </td>
                    <td>
                        {#if accessGrantDescriptors.length > 0 && accessGrantDescriptors?.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType) ? permissionObject.update(accessGrantDescriptors.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType).permissions) : false}
                            <span
                                class="icon has-text-success {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleUpdate(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                ).permissions
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-on" />
                            </span>
                        {:else}
                            <span
                                class="icon has-text-danger {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleUpdate(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                )?.permissions || []
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-off" />
                            </span>
                        {/if}
                    </td>
                    <td>
                        {#if accessGrantDescriptors.length > 0 && accessGrantDescriptors?.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType) ? permissionObject.delete(accessGrantDescriptors.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType).permissions) : false}
                            <span
                                class="icon has-text-success {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleDelete(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                ).permissions
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-on" />
                            </span>
                        {:else}
                            <span
                                class="icon has-text-danger {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleDelete(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                )?.permissions || []
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-off" />
                            </span>
                        {/if}
                    </td>
                    <td>
                        {#if accessGrantDescriptors.length > 0 && accessGrantDescriptors?.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType) ? permissionObject.all(accessGrantDescriptors.find((descriptor) => descriptor.resourceType === permissionObject.accessGrantType).permissions) : false}
                            <span
                                class="icon has-text-success {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleAll(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                ).permissions
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-on" />
                            </span>
                        {:else}
                            <span
                                class="icon has-text-danger {editable
                                    ? 'cursor'
                                    : ''}"
                                on:click={() => {
                                    if (editable) {
                                        changePermissionsHandler(
                                            permissionObject.toggleAll(
                                                accessGrantDescriptors.find(
                                                    (descriptor) =>
                                                        descriptor.resourceType ===
                                                        permissionObject.accessGrantType
                                                )?.permissions || []
                                            ),
                                            permissionObject.accessGrantType
                                        );
                                    }
                                }}
                            >
                                <i class="fas fa-toggle-off" />
                            </span>
                        {/if}
                    </td>
                </tr>
            {/each}
        </tbody>
    </table>
</div>

<style>
    .full-width {
        width: 100%;
        position: relative;
    }

    .cursor {
        cursor: pointer;
    }

    table,
    thead,
    th {
        /* background-color: #e6e6e6 !important; */
    }

    .fa-toggle-on {
        color: #14acab;
    }
</style>
